import AbstractDots from "../../assets/images/Abstract_Dots.svg";
import CSS from "./styles.module.css";

// Animate on Scroll
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const StepsContentNeo = () => {
	useEffect(() => {
		AOS.init({ duration: 500, delay: 0 });
	}, []);

	return (
		<div className={CSS.StepsContentNeoContainer} data-aos="fade-up">
			<div className={CSS.StepsContentNeo}>
				<div className={CSS.Heading}>
					<h2>How to use the AI HR Email Template Generator?</h2>
				</div>
				<div className={CSS.StepsContainer}>
					<div className={CSS.StepsPipeline}></div>
					<div className={CSS.StepsContent}>
						<div className={CSS.Steps}>
							<div className={`${CSS.Content}`}>
								<div className={CSS.StepCounter}>1</div>
								<h3>Select the Email Type</h3>
								<p>
									Choose the HR email type to get started. We have a vast list
									of useful HR email templates for every HR communication.
								</p>
							</div>
						</div>

						<div className={CSS.Steps}>
							<div className={`${CSS.Content} ${CSS.cRight}`}>
								<div className={CSS.StepCounter}>2</div>
								<h3>
									Choose a Language <span>(Optional)</span>
								</h3>
								<p>
									We offer Recooty's AI Email Template Generator in multiple
									languages. Now great emails for seamless communications can be
									generated in{" "}
									<b>
										English (US), English (UK), German, French, Spanish, Arabic,
										Portuguese, Polish, and Italian.
									</b>
								</p>
							</div>
						</div>

						<div className={CSS.Steps}>
							<div className={`${CSS.Content} ${CSS.cRight}`}>
								<div className={CSS.StepCounter}>3</div>
								<h3>Click Generate</h3>
								<p>
									Click the generate button and our AI HR email template
									generator will create your professional email in seconds.
								</p>
							</div>
						</div>

						<div className={CSS.Steps}>
							<div className={`${CSS.Content} ${CSS.cRight}`}>
								<div className={CSS.StepCounter}>4</div>
								<h3>Add Smart Inputs</h3>
								<p>
									Add smart input fields that intelligently pick up all the text
									fields for you. It makes your emails ready to use & perfectly
									personalized.
								</p>
							</div>
						</div>

						<div className={CSS.Steps}>
							<div className={`${CSS.Content}`}>
								<div className={CSS.StepCounter}>5</div>
								<h3>Copy/Modify</h3>
								<p>
									Copy your professionally crafted email and use it for your HR
									communications. If you'd like to edit it, simply click on the
									text and modify it as per your requirements.
								</p>
							</div>
						</div>
					</div>
					<div className={CSS.StepsImg}>
						<img
							src={AbstractDots}
							alt="How to use the AI HR email template generator?"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StepsContentNeo;
